import template from './all-rooms-area.jade';
import validation from '../../../services/validation';
import { patterns } from '../../../services/validationPatterns';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular
    .module('cian.addForm.allRoomsArea', [])
    .directive('cianAfAboutObjectAllRoomsArea', [() => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'adTooltipsService', 'analyticsService', 'deviceService', 'popupService', function ($scope, adTooltipsService, analyticsService, deviceService, popupService) {
          this.isMobile = deviceService.isMobile;
          this.modalHintTitle = 'Площадь комнат';
          this.tooltipText = '';
          this.pattern = patterns.allRoomsArea;

          this.validation = validation(this.form, 'allRoomsArea', {
            pattern: 'Введите числа как указано в примере: 18+14-10',
          });

          initializeSegmentInputTooltips({
            controller: this,
            $scope,
            adTooltipsService,
            adAnalyticsCategory: analyticsService.adAnalyticsCategory,
            tooltipsKey: 'allRoomsArea',
            trackingLabel: 'all-rooms-area-hint',
            popupService,
            isMobile: this.isMobile,
          });
        }],
        controllerAs: 'allRoomsArea',
        template,
    })])
    .name;
